import { AxiosResponse } from 'axios';
import ListWithTotal from 'common/dto-types/list-with-total-dto';
import CityDto from 'common/dto-types/city-dto';
import CountryDto from 'common/dto-types/country-dto';
import axiosServices, { PaginationAndFiltersParams, buildQueryParams } from 'utils/axios';
import { COUNTRY_API_URL } from 'pages/country-list-page/api';

export const CITY_API_URL = '/cities';

export const createCity = async (city: CityDto): Promise<AxiosResponse | null | undefined> => {
    try {
        return await axiosServices.post(CITY_API_URL, city);
    } catch (err) {
        const errorResponse = err as AxiosResponse;
        if (errorResponse) return errorResponse;
        return null;
    }
};

export const updateCity = async (city: CityDto): Promise<AxiosResponse | null | undefined> => {
    try {
        return await axiosServices.put(CITY_API_URL, city);
    } catch (err) {
        const errorResponse = err as AxiosResponse;
        if (errorResponse) return errorResponse;
        return null;
    }
};

export const deleteCity = async (id: number): Promise<AxiosResponse | null | undefined> => {
    try {
        return await axiosServices.delete(`${CITY_API_URL}/${id}`);
    } catch (err) {
        const errorResponse = err as AxiosResponse;
        if (errorResponse) return errorResponse;
        return null;
    }
};

export const fetchAllCountries = async (): Promise<CountryDto[]> => {
    try {
        const res = await axiosServices.get(COUNTRY_API_URL);
        return Array.isArray(res.data) ? res.data : res.data.elements;
    } catch (err) {
        console.error(err);
        return [];
    }
};

export const fetchCityList = async (
    params: PaginationAndFiltersParams,
): Promise<ListWithTotal<CityDto> | null | undefined> => {
    try {
        const res = await axiosServices.get(`${CITY_API_URL}/list${buildQueryParams(params)}`);
        return res.data;
    } catch (err) {
        // TODO: Implement a proper way to handle errors
        // https://fifadigital.atlassian.net/browse/FMH-2075
        console.error(err);
        return null;
    }
};
